import React, { useEffect, useState } from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { useGlobalContext } from "@root/context/global-context";
import SearchZoomOutIcon from "@root/assets/icons/zoom-out";
import SearchZoomOInIcon from "@root/assets/icons/zoom-in";
import LoopArrowIcon from "@root/assets/icons/looparrowicon";
import { ImageContainer, LeftContainer, StyledButton } from "./style";

export function DrawingPreview() {
  const [scale, setScale] = useState(1); // Default 100%
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const { isSidebarOpen, setIsSidebarOpen } = useGlobalContext();

  useEffect(() => {
    setIsSidebarOpen(false);

    // Simulate backend image fetch
    fetchImageFromBackend();
  }, []);

  const fetchImageFromBackend = async () => {
    try {
      // Replace this with your actual backend API call
      const imageUrl =
        "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=800&q=80";
      setImageSrc(imageUrl);
    } catch (error) {
      console.error("Error fetching image:", error);
    }
  };

  const zoomIn = () => setScale((prev) => Math.min(prev + 0.1, 1)); // Max 1x (100%)
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.1, 0.5)); // Min 0.5x (50%)
  const resetZoom = () => setScale(1); // Back to 100%

  return (
    <Flex h="100%">
      {/* Left side with image */}
      <LeftContainer>
        {/* Zoom controls */}
        <Flex position="absolute" top="4%" zIndex={1} gap={2}>
          <StyledButton
            aria-label="Arrow Left"
            icon={<span>{"❮"}</span>}
            onClick={()=>{console.log("logic to be implemented")}}
          />

          <StyledButton
            aria-label="Arrow Right"
            icon={<span>{"❯"}</span>}
            onClick={()=>{console.log("logic to be implemented")}}
          />

          <StyledButton
            aria-label="Zoom In"
            icon={<SearchZoomOInIcon width="24px" height="24px" />}
            onClick={zoomIn}
          />

          <Box py="4" color="black">
            {Math.round(scale * 100)}%
          </Box>

          <StyledButton
            aria-label="Zoom Out"
            icon={<SearchZoomOutIcon width="24px" height="24px" />}
            onClick={zoomOut}
          />

          <StyledButton
            aria-label="Reset Zoom"
            icon={<LoopArrowIcon />}
            onClick={resetZoom}
          />
        </Flex>

        {/* Image */}
        <ImageContainer>
          {imageSrc ? (
            <Image
              src={imageSrc}
              alt="Drawing"
              transform={`scale(${scale})`}
              transformOrigin="center"
              transition="transform 0.2s ease"
              w="100%"
              h="100%"
              objectFit="cover"
            />
          ) : (
            <Box color="gray.500" fontSize="sm" p={4}>
              Loading image...
            </Box>
          )}
        </ImageContainer>
      </LeftContainer>

      {/* Right side with content */}
      <Box flex="1" p={6} overflowY="auto"></Box>
    </Flex>
  );
}
